import 'core-js/features/set-immediate'
import 'core-js/features/promise'
import 'core-js/features/object/assign'
import 'core-js/features/object/values'
import 'core-js/features/array/find'
import 'core-js/features/array/from'
import 'core-js/features/symbol'
import 'core-js/features/string/replace'
import 'classlist-polyfill'
import 'whatwg-fetch'

// ChildNode.remove() polyfill, hopefully landing in core-js soon.
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
